import { useEffect, useRef } from "react";
import styles from "./NaverMap.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

// 전역 script 로딩 상태 저장 (중복 로딩 방지 코드)
let mapScriptLoadingPromise = null;

export default function NaverMap({ location }) {
  // 네이버 맵
  const mapElementRef = useRef(null); // 실제 DOM
  const mapRef = useRef(null); // 지도 인스턴스
  const markerRef = useRef(null); // 마커

  useEffect(() => {
    if (!location) return;

    // 지도 스크립트 로드
    const loadMapScript = () => {
      if (mapScriptLoadingPromise) {
        return mapScriptLoadingPromise;
      }

      mapScriptLoadingPromise = new Promise((resolve) => {
        //로드 되어있는 경우
        if (window.naver && window.naver.maps) {
          resolve();
          return;
        }

        const mapScript = document.createElement("script");
        mapScript.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.REACT_APP_NAVER_MAP_KEY}`;
        mapScript.async = true;

        mapScript.onload = () => {
          resolve();
        };

        document.head.appendChild(mapScript);
      });

      return mapScriptLoadingPromise;
    };

    const initMap = () => {
      const { lat, lng, scale } = location;

      const position = new window.naver.maps.LatLng(lat, lng);

      //최초 1회만 지도를 생성함
      if (!mapRef.current) {
        mapRef.current = new window.naver.maps.Map(mapElementRef.current, {
          center: position,
          zoom: scale,
        });

        markerRef.current = new window.naver.maps.Marker({
          position,
          map: mapRef.current,
        });

        return;
      }

      mapRef.current.panTo(position); // 부드러운 이동
      markerRef.current.setPosition(position); //마커 이동
      mapRef.current.setZoom(scale); // 배율
    };

    loadMapScript().then(() => {
      initMap();
    });
  }, [location]);

  return (
    <div className={cx("mapWrapper")}>
      <div ref={mapElementRef} className={cx("mapContainer")}></div>
    </div>
  );
}
